// !!! DO NOT DELETE THIS FILE. IT'S NEEDED FOR process.env.NODE_ENV === 'test'
export default {};
